export default __webpack_public_path__ + "static/media/croptop-medium-back.03afe137.jpg";